import { Button, Modal, Text } from '@ksyos/design-system';
import type { ServiceType } from '@common/enums';
import { formatString } from '@common/utils/formatString';
import { getSelectedLanguage } from '@frontend/translate';

export interface IProcessAlreadyTakenModal {
    isOpen: boolean;
    onClose: () => void;
    serviceType: ServiceType;
}

export function ProcessAlreadyTakenModal(props: IProcessAlreadyTakenModal) {
    const language = getSelectedLanguage();

    return (
        props.isOpen && (
            <Modal
                isOpen={props.isOpen}
                onClose={props.onClose}
                size="small"
            >
                <>
                    <Modal.Header />
                    <Modal.CloseButton />
                    <Modal.Body>
                        <Text>
                            {formatString(language.request.processAlreadyTakenByColleague, {
                                taskName: language.serviceTypeEnum[props.serviceType].toLowerCase(),
                            })}
                        </Text>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button
                            onClick={() => props.onClose()}
                            variant="solid"
                        >
                            {language.common.close}
                        </Button>
                    </Modal.Footer>
                </>
            </Modal>
        )
    );
}
